import { useState, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setFileReport, setOpenRModal } from '../../../reducers/filesAllocationReducer'
import { Modal as RModal } from 'rsuite';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from "react-headless-accordion";
import Button from '../../common/Button';
import { setDeduperFiles, setFileManageSection, setUnallocatedFiles } from '../../../reducers/filesReducer';
import { getRequest } from '../../../config';

const isObjectId = (str) => typeof str === 'string' && /^[0-9a-fA-F]{24}$/.test(str);

const OpenRModalComponent = () => {

    const dispatch = useDispatch()
    const { company, tab, rModalData, openRModal, fileReport, moduleId } = useSelector(state => state.fileAllocation)
    const { unallocatedFiles, deduperReports } = useSelector(state => state.files)
    const { selectedCompany } = useSelector(state => state.company)
    const [selectedQuestion, setSelectedQuestion] = useState(null)
    const [forwardData, setForwardData] = useState(null)
    const [curQno, setCurQno] = useState(null)
    const [tempSections, setTempSections] = useState([])

    // Resolve module identifier for by-name endpoint
    const effectiveModuleName = useMemo(() => {
        if (fileReport?.moduleKey) return fileReport.moduleKey;
        if (fileReport?.moduleSlug) return fileReport.moduleSlug;
        if (fileReport?.moduleName && !isObjectId(fileReport.moduleName)) return fileReport.moduleName;
        if (tab) return tab;
        return null;
    }, [fileReport?.moduleKey, fileReport?.moduleSlug, fileReport?.moduleName, tab]);

    const effectiveCompanyId = useMemo(() => {
        return company?._id || selectedCompany?._id || null;
    }, [company?._id, selectedCompany?._id]);

    // Fetch TempSections + questions from by-name endpoint
    useEffect(() => {
        if (!openRModal || !effectiveModuleName) {
            setTempSections([]);
            return;
        }
        const url = effectiveCompanyId
            ? `/modules/temp-modules/by-name/${encodeURIComponent(effectiveModuleName)}?companyId=${encodeURIComponent(effectiveCompanyId)}`
            : `/modules/temp-modules/by-name/${encodeURIComponent(effectiveModuleName)}`;

        getRequest(url).then(res => {
            if (res?.code === 200 && res.body?.sections) {
                setTempSections(res.body.sections);
            }
        });
    }, [openRModal, effectiveModuleName, effectiveCompanyId]);
    const Chevron = ({ className = "" }) => {
        return (
            <svg className={className} fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"></path></svg>
        )
    };

    const handleClose = () => {
        setSelectedQuestion(null)
        setForwardData(null)
        setCurQno(null)
        dispatch(setOpenRModal(false))
    }

    const handleConfirm = () => {
        if (rModalData?.from && rModalData?.from === "fileReport" && rModalData?.actionType === "move") {
            dispatch(setFileReport(forwardData))
        } else if (rModalData?.from && rModalData?.from === "deduper") {
            dispatch(setDeduperFiles(forwardData))
        } else if (rModalData?.from && rModalData?.from === "section") {
            dispatch(setFileManageSection(forwardData))
        } else {
            dispatch(setUnallocatedFiles(forwardData))
        }
        handleClose()
    }

    const selectTargetSection = async (fileKey, qNo, name, from, index) => {
        setSelectedQuestion(qNo)
        if (from && from === "fileReport" && rModalData?.actionType === "move") {
            setCurQno(fileReport.importResult[fileKey].section[0])
            setForwardData({
                ...fileReport,
                importResult: {
                    ...fileReport.importResult,
                    [fileKey]: {
                        ...fileReport.importResult[fileKey],
                        section: [qNo],
                        originalSection: [qNo],
                        isModified: true,
                    }
                }
            })
        }
        if (from && from === "unallocated" && rModalData?.actionType === "reallocate") {
            setForwardData([...unallocatedFiles].reduce((acc, current, _index) => {
                if (`${_index}` === `${rModalData.index}`) {
                    acc.push({
                        ...current,
                        sectionNo: qNo,
                        name: name
                    })
                } else {
                    acc.push(current)
                }
                return acc
            }, []))
        }
        if (from && from === "deduper") {
            const selectedDeuper = deduperReports && deduperReports.selectedDeuper && deduperReports.selectedDeuper.length ? [...deduperReports.selectedDeuper] : [];

            const modifiedDeduperResult = {
                ...deduperReports.deduperResult,
                [rModalData.key]: deduperReports.deduperResult[rModalData.key].flatMap((item, index) => {
                    if (index === rModalData.index) {
                        selectedDeuper.push({
                            ...item,
                            curQno: item.qNo, qNo,
                            isModified: true,
                            actionType: rModalData.actionType,
                            key: item.file.key,
                            index: rModalData.index
                        });

                        if (rModalData?.actionType === "move") {
                            return [{
                                ...item,
                                qNo,
                                isModified: true,
                                name: name,
                                actionType: rModalData.actionType
                            }];
                        } else {
                            return [
                                {
                                    ...item,
                                },
                                {
                                    ...item,
                                    qNo,
                                    isModified: true,
                                    name: name,
                                    actionType: rModalData.actionType
                                }
                            ];
                        }
                    }
                    return item;
                })
            };
            setForwardData({
                ...deduperReports,
                deduperResult: modifiedDeduperResult,
                selectedDeuper
            });
        }

        if (from && from === "section") {
            const selectedFile = [...rModalData.section.files].filter((_f, _i) => _i === rModalData.index)
            const sectionData = {
                ...rModalData.section,
                files: rModalData.actionType === "move"
                    ? [...rModalData.section.files].filter((_f, _i) => _i !== rModalData.index)
                    : qNo === (rModalData.section.qNo ?? rModalData.section.qNo) ? [...rModalData.section.files, ...selectedFile] : rModalData.section.files
            }

            setForwardData({
                sectionData,
                selectFile: selectedFile,
                actionType: rModalData.actionType,
                qNo
            })
        }
    };

    const getSectionDropDown = (section, fileKey, from, index) => {
        const qNo = section.sectionNo || section.no; // Section number
        const name = section.sectionName || section.name; // Section name

        if (section.subFolders && !qNo.includes(".") && (selectedCompany['subscription'] && selectedCompany['subscription'] === "Pro")) {
            // Main section with dropdown (only for top-level sections)
            return (
                <AccordionItem key={qNo}>
                    {({ open }) => (
                        <div className={"lightBorder mb0-5rem w100 jcsb cp "}>
                            {/* Dropdown Header */}
                            <AccordionHeader className="df aic jcsb bg1 w100 dropdown-section-header px2rem" >
                                <h3 className="c15 fw400 tal">
                                    {qNo}. {name}
                                </h3>
                                <Chevron className={`c3 td300 ml0-5rem ${!open ? "tr90deg" : "tr270deg"} mxw1rem`} />
                            </AccordionHeader>

                            {/* Dropdown Body */}
                            <AccordionBody>
                                <div>
                                    {Object.keys(section.subFolders).map((key) => {
                                        const subFolder = section.subFolders[key];
                                        return getSectionDropDown(
                                            subFolder,
                                            fileKey,
                                            from,
                                            index
                                        );
                                    })}
                                </div>
                            </AccordionBody>
                        </div>
                    )}
                </AccordionItem>
            );
        } else if (section.subFolders && (selectedCompany['subscription'] && selectedCompany['subscription'] === "Pro")) {
            return (
                <div key={`subfolder-${qNo}`}>
                    <div onClick={() => selectTargetSection(fileKey, qNo, name, from, index)} className="rs-dropdown-item">
                        {qNo}. {name}
                    </div>
                    <div style={{ paddingLeft: '36px' }}>
                        {Object.keys(section.subFolders).map((key) => {
                            const subFolder = section.subFolders[key];
                            return getSectionDropDown(
                                subFolder,
                                fileKey,
                                from,
                                index
                            );
                        })}
                    </div>
                </div>
            );
        } else {
            return (
                <div
                    key={qNo}
                    className={`rs-dropdown-item ${(selectedQuestion && qNo === selectedQuestion) ? 'selected' : ''}`}
                    onClick={() => selectTargetSection(fileKey, qNo, name, from, index)}
                >
                    {qNo}. {name}
                </div>
            );
        }
    };

    const getTempSectionsAccordion = (key, from, index) => {
        if (!tempSections?.length) {
            return <p className="c15 fs0-875rem tac op60 p1rem">No sections available</p>;
        }

        const hasSubFolders = (section) =>
            !!(section?.subFolders && typeof section.subFolders === 'object' && Object.keys(section.subFolders).length > 0);

        const renderTempSubFolders = (subFolders, level = 1) => {
            if (!subFolders || typeof subFolders !== 'object') return null;

            return Object.keys(subFolders).map((subKey) => {
                const subFolder = subFolders[subKey];
                if (!subFolder) return null;

                const qNo = subFolder.no;
                const name = subFolder.name || subFolder.sectionName || 'Sub section';
                const nested = subFolder.subFolders && typeof subFolder.subFolders === 'object'
                    ? subFolder.subFolders
                    : null;

                return (
                    <div key={`temp-sub-${qNo || subKey}`}>
                        <div
                            className={`rs-dropdown-item ${(selectedQuestion && qNo === selectedQuestion) ? 'selected' : ''}`}
                            style={{ paddingLeft: `${1 + (level * 1.25)}rem` }}
                            onClick={() => selectTargetSection(key, qNo, name, from, index)}
                        >
                            {(qNo ? `${qNo}. ` : '')}{name}
                        </div>
                        {nested && renderTempSubFolders(nested, level + 1)}
                    </div>
                );
            });
        };

        return (
            <div>
                {tempSections.map(section => {
                    const qNo = section.sectionNo || section.no;
                    const name = section.sectionName || section.name || 'Section';

                    if (!hasSubFolders(section)) {
                        return (
                            <div
                                key={`temp-section-${section._id || qNo}`}
                                className={`rs-dropdown-item ${(selectedQuestion && qNo === selectedQuestion) ? 'selected' : ''}`}
                                onClick={() => selectTargetSection(key, qNo, name, from, index)}
                            >
                                {(qNo ? `${qNo}. ` : '')}{name}
                            </div>
                        );
                    }

                    return (
                        <Accordion key={`temp-accordion-${section._id || qNo}`}>
                            <AccordionItem>
                                {({ open }) => (
                                    <div className="lightBorder mb0-5rem w100 cp">
                                        <AccordionHeader className="df aic jcsb bg1 w100 dropdown-section-header px2rem">
                                            <h3 className="c15 fw400 tal fs0-875rem">
                                                {(qNo ? `${qNo}. ` : '')}{name}
                                            </h3>
                                            <Chevron
                                                className={`c3 td300 ml0-5rem ${open ? 'tr270deg' : 'tr90deg'} mxw1rem`}
                                            />
                                        </AccordionHeader>

                                        <AccordionBody>
                                            <div className="py0-25rem">
                                                {renderTempSubFolders(section.subFolders, 1)}
                                            </div>
                                        </AccordionBody>
                                    </div>
                                )}
                            </AccordionItem>
                        </Accordion>
                    );
                })}
            </div>
        );
    };

    if (!openRModal) return <></>;

    const isTempModule = !!moduleId;

    return (
        <RModal overflow={true} open={openRModal} onClose={handleClose} style={{ zIndex: '2000' }}>
            <RModal.Header>
                <div className='df aic jcfs'>
                    {["move", "reallocate"].includes(rModalData.actionType) ? (
                        <>
                            <img src={require("../../../../images/dataRepo/send.svg")} alt="moveFileIcon" style={{ width: '40px', height: '40px' }} />
                            <span className="c15 fw600 ml0-5rem fs20px">
                                {"reallocate" === rModalData.actionType ? "Reallocate File" : "Move File"}
                            </span>
                        </>
                    ) : (
                        <>
                            <img src={require("../../../../images/dataRepo/copy.svg")} alt="moveFileImg" style={{ width: '40px', height: '40px' }} />
                            <span className="c15 fw600 ml0-5rem fs20px">Copy File</span>
                        </>
                    )}
                </div>
                <p className='c3'>{rModalData.fileName}</p>
                <p className="c15 fs0-75rem op60 mt0-25rem">
                    Select destination section
                </p>
            </RModal.Header>

            <RModal.Body style={{ maxHeight: '550px', paddingRight: '16px' }} className="lightScrollbar">
                {getTempSectionsAccordion(rModalData.key, rModalData.from, rModalData.index)}
            </RModal.Body>

            <div className="w100 tac">
                <Button
                    text={rModalData.actionType === "copy" ? "Copy File" : "Move File"}
                    btnType="warning"
                    onClick={handleConfirm}
                    customClassName="mla mra c1"
                    disabled={selectedQuestion === null}
                />
            </div>
        </RModal>
    );
}

export default OpenRModalComponent